import React, { useEffect, useState } from "react";
import { Page, FormGroup } from "components/common";
import { Control } from "react-redux-form";
import { Row, Col } from "reactstrap";
import Select from "react-select";
import BackButton from "../../../../components/refactoring/BackButton"
import { createDelayedFunction } from 'Helpers'
import { useForm } from "hooks";
import { AttachmentLine } from './AttachmentLine'
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";
import LoadingMsg from "components/common/LoadingMsg";

export const TranslateTypes = (types, t) => {
  for (let type of types) {
    if (type['value'] === "Iqama") {
      type['label'] = t("Iqama")
    }
    else if (type['value'] === "Contract") {
      type['label'] = t("Contract")
    }
  }
  return types
}

export const List = ({ payroll, t, url = "employee_attachments", model = "local", history, match }) => {
  const { id } = match.params;
  const { dispatch, setValue, Form, save, loaded, load, getTitle, value } = useForm({
    model,
  });
  
  const location = useLocation();
  const params = new URLSearchParams(location.search)
  
  const urlID = params.get("id") 
  const urlName = params.get("name") 

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [reload, setReload] = useState(false)
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState([])

  const loadItems = (client, url) => client.get(`${url}`).get("data");

  useEffect(
    () => {
      void (async () => {

        const [employees] = await Promise.all([

          loadItems(payroll, "employees").map((x) => ({
            label: x.full_name,
            value: x.id,
          })),
        ]);
        setEmployees(employees);
      })()
    },
    []
  );

  useEffect(() => {
    if (urlID) {
      setSelectedEmployee(urlID)
    }
    selectedEmployee &&
      void (async () => {
        setLoading(true)
        const [items] = await Promise.all([
          loadItems(payroll, `employee_attachments/${selectedEmployee}/all`),
        ]);
        setItems(items)
        setLoading(false)
      })()
  }, [selectedEmployee, reload])

  function getEmployee(value) {
    if (value && Number.isInteger(value)) {
      setSelectedEmployee(value)
    }
    return value
  }
  const getEmployeesDelayed = createDelayedFunction(getEmployee, 500);


  return (
    <Page title={getTitle(id, "Employee's Attachments")}>
      <BackButton />
      <div className="cnt">
      {!urlID && 
        <div className="border p-3 my-3">
          <Form>
            <Row>
              <Col>
                <FormGroup className="pb-2 pt-2"
                  label="Employee *"
                  model=".employee"
                  addControlClass={false}
                >
                  <Control.text style={{ backgroundColor: '#F4F7FE' }}
                    model=".employee"
                    component={Select}
                    options={employees}
                    simpleValue
                    clearable={false}
                    getValue={getEmployeesDelayed}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </div>
      }        
      {urlName && 
        <div className="text-center" style={{fontSize:"1.3em"}}>
          <Trans>Attatchments for</Trans> : <strong>{urlName}</strong>
        </div>
      }
      <div className="border p-3 my-3">
        {loading ? <LoadingMsg/>:
        <>
          {selectedEmployee ?
            (
              <>
                {
                  items &&
                  items.map((item, index) => (
                    <AttachmentLine payroll={payroll} t={t} employee={selectedEmployee} url={url} history={history} old={item} key={`${selectedEmployee}-${index}`} setReload={setReload}></AttachmentLine>
                  ))
                }
                <AttachmentLine payroll={payroll} t={t} employee={selectedEmployee} url={url} history={history} old={null} setReload={setReload} key={`${selectedEmployee}-${items?.length || 0}`}></AttachmentLine>
              </>
            )
            :
            <div className="no-items text-center"><Trans>Select an employee to add attachments to</Trans></div>
          }
        </>
        }
      </div>
      </div>

    </Page>
  );
};

export default List;
